<template>
  <div class="animated fadeIn">
    <b-card no-body>
      <b-row no-gutters>
        <b-col>
          <pos-categories :categories="categories" @categoryClicked="categoryClicked"></pos-categories>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
          <pos-products :products="products" @productClicked="productClicked"></pos-products>
        </b-col>
      </b-row>
    </b-card>
    <div>
      <b-modal
        ref="modalVariablePriceQty"
        title="Variable Bhent and Quantity"
        hide-footer
        no-enforce-focus
        no-close-on-backdrop
        centered
        size="lg"
      >
        <variable-prd-price-modal  @success="acceptVariablePriceQty" @cancel="cancelVariablePriceQty" :product="variablePriceProduct" />
      </b-modal>
    </div>

  </div>
</template>


<script>
import Vue from "vue";
import POSProducts from "./components/POSProducts";
import POSCategories from "./components/POSCategories";
import VariablePrdPriceModal from "./components/VariablePrdPriceModal";

export default {
  name: "CategoryProductPanel",
  props: {
    systemid: {
      type: String,
      default: 0,
    }
  },
  components: {
    "pos-products": POSProducts,
    "pos-categories": POSCategories,
    "variable-prd-price-modal": VariablePrdPriceModal
  },
  data: function() {
    return {
      variablePriceProduct: null,
      products: [],
      categories: []
    };
  },
  methods: {
    productClicked(product) {
      if (product != null && product.isCategory == "Y") {
        let params = {
          systemid: this.systemid,
          categoryid: product.id
        };
        this.getProductsByCatId(params);

      } else {

        if(product.isvariable == true){
          this.variablePriceProduct = JSON.parse(JSON.stringify(product));
          this.$refs.modalVariablePriceQty.show();
        }else{
          const selectedProduct = JSON.parse(JSON.stringify(product));
          this.$emit("productSelected", selectedProduct);
        }

      }
    },
    categoryClicked(category) {
      let params = {
        systemid: this.systemid,
        categoryid: category.id
      };

      this.getProductsByCatId(params);
    },
    acceptVariablePriceQty(product) {
      this.$refs.modalVariablePriceQty.hide();
      const selectedProduct = JSON.parse(JSON.stringify(product));
      this.variablePriceProduct = null;
      this.$emit("productSelected", selectedProduct);
    },
    cancelVariablePriceQty() {
      this.$refs.modalVariablePriceQty.hide();
      this.variablePriceProduct = null;

    },
    updated: function() {
      this.$nextTick(function() {
        this.$emit("updated");
      });
    },
    getProductsByCatId(params){
      this.$store.dispatch('pos/getCatProductsByCatId', params)
        .then(response => {
          if(response.data.success == false){
              this.showErrorMsg({
                message: response.data.error
              });
          }
          else{
            this.products = response.data.data;
            if(Object.keys(this.products).length <= 0){
                this.products=[];
            }

          }
        })
        .catch(error => {

          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          }
          else if (error.response.status == 422){
              this.showErrorMsg({
                message: error.response.data.message
              });

          }
          else {
            this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
          }
        })
    }
  },

  created(){
    if(this.categories.length == 0){
      let params = {
        systemid: this.systemid
      }
      this.$store.dispatch('pos/getMainCategories', params)
        .then(response => {
          if(response.data.success == false){
              this.showErrorMsg({
                message: response.data.error
              });
          }
          else{
            this.categories = response.data.data.data;
            if(Object.keys(this.categories).length <= 0){
              this.showSuccessMsg({
                message: 'No main categories found for this system.'
              });
            }
            this.products=[];

          }
        })
        .catch(error => {

          if (error.response.status == 400) {
            this.showErrorMsg({
              message: error.response.data.message
            })
          }
          else if (error.response.status == 422){
              this.showErrorMsg({
                message: error.response.data.message
              });

          }
          else {
            this.showErrorMsg({message: "Something went wrong. Please contact administrator."})
          }
        })
    }
  }

};
</script>

<style>
</style>
